import { apiService } from './index';

// Inport types
import { Template } from '../shared/types/template';

export const asyncGetTemplateByCode = async (
    code: string
): Promise<Template | undefined> => {
    try {
        const { items }: any = await apiService.get(
            `/api/template/by-code/${code}`
        );
        return items;
    } catch (error) {}
};
